import type { SessionFilters, Step } from '../api/visitors'
import { STEP_LABEL } from './visitorsFormat'

const STEPS: Step[] = ['visit', 'engaged', 'considered', 'checkout', 'paid']
const KEYS = ['channel', 'device', 'country', 'landing', 'campaign', 'verdict',
  'exit', 'active', 'referrer_host', 'channel_detail', 'region'] as const

export function filtersFromSearch(sp: URLSearchParams): SessionFilters {
  const f: SessionFilters = {}
  const step = sp.get('step') as Step | null
  if (step && STEPS.includes(step)) f.step = step
  for (const k of KEYS) { const v = sp.get(k); if (v) f[k] = v }
  return f
}

export function filtersToSearch(f: SessionFilters): Record<string, string> {
  const out: Record<string, string> = {}
  for (const [k, v] of Object.entries(f)) if (v) out[k] = String(v)
  return out
}

export function describeFilters(f: SessionFilters): string[] {
  const out: string[] = []
  if (f.step) out.push(`${STEP_LABEL[f.step]} or further`)
  if (f.channel) out.push(`Channel: ${f.channel}`)
  if (f.device) out.push(`Device: ${f.device}`)
  if (f.country) out.push(`Country: ${f.country}`)
  if (f.landing) out.push(`Landing: ${f.landing}`)
  if (f.exit) out.push(`Reading now: ${f.exit}`)
  if (f.active) out.push(`Active in the last ${f.active} min`)
  if (f.referrer_host) out.push(`Referrer: ${f.referrer_host}`)
  if (f.channel_detail) out.push(`Source: ${f.channel_detail}`)
  if (f.region) out.push(`Region: ${f.region}`)
  if (f.campaign) out.push(`Email campaign: ${f.campaign}`)
  if (f.verdict === 'all') out.push('All verdicts')
  else if (f.verdict && f.verdict !== 'human') out.push(`Verdict: ${f.verdict}`)
  return out
}
